import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { loadEffect, SaveStatus, LoadState$2, getTranslationFrom, GlobalDependencies$reflection } from "../../Global.js";
import { record_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import * as react from "react";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { loadActivateFeeTemplate, deactivateFeeTemplate, createNewFeeTemplate, saveFeeTemplate, loadContractAttributes as loadContractAttributes_1, loadFeeTemplates as loadFeeTemplates_1 } from "./Api.js";
import { ofArray, tryFind, contains, filter } from "../../fable_modules/fable-library.3.7.20/List.js";
import { uncurry, stringHash } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { parse } from "../../fable_modules/fable-library.3.7.20/Int32.js";
import { FeeTemplateTableProps, renderFeeTemplateTable, FeeTemplateModalProps, toFeeTemplateDTO, renderFeeTemplateModal } from "./Common.js";
import { error } from "../../Components/Message/Message.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { ButtonProps, defaultProps, main } from "../../Components/Button/Button.js";
import { dotsLoading } from "../../ViewUtils.js";
import { stackClasses } from "../../Utils.js";
import { HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import "../../../src/Containers/FeeTemplates/View.scss";


export class ContractTypeFeeTemplatesProps extends Record {
    constructor(GlobalDependencies, ContractTypeCode) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.ContractTypeCode = ContractTypeCode;
    }
}

export function ContractTypeFeeTemplatesProps$reflection() {
    return record_type("Containers.FeeTemplates.ContractTypeFeeTemplates.ContractTypeFeeTemplatesProps", [], ContractTypeFeeTemplatesProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["ContractTypeCode", string_type]]);
}

export const render = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_6, arg_11;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const editFeeTemplateModalState = react.useState(void 0);
    const createFeeTemplateModalIsOpenState = react.useState(false);
    const feeTemplatesState = react.useState(new LoadState$2(0));
    const feeTemplateSaveState = react.useState(new SaveStatus(0));
    const contractAttributesLoadState = react.useState(new LoadState$2(0));
    const loadFeeTemplates = () => {
        feeTemplatesState[1](new LoadState$2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(loadFeeTemplates_1(props.GlobalDependencies.ClientNr, props.ContractTypeCode), (_arg) => {
            const result = _arg;
            const arg_2 = (result.tag === 1) ? (new LoadState$2(3, result.fields[0])) : (new LoadState$2(2, filter((ft) => contains(props.ContractTypeCode, ft.ContractTypeCodes, {
                Equals: (x, y) => (x === y),
                GetHashCode: stringHash,
            }), result.fields[0])));
            feeTemplatesState[1](arg_2);
            return singleton.Zero();
        })));
    };
    react.useEffect(() => {
        loadFeeTemplates();
        loadEffect(() => loadContractAttributes_1(props.GlobalDependencies.ClientNr), (arg) => {
            contractAttributesLoadState[1](arg);
        });
    }, [props.GlobalDependencies, props.ContractTypeCode]);
    const editFeeTemplateModalHtml = react.useMemo(() => {
        const matchValue = [editFeeTemplateModalState[0], feeTemplatesState[0], contractAttributesLoadState[0]];
        let pattern_matching_result, contractAttributes, feeTemplateNr, feeTemplates_1;
        if (matchValue[0] != null) {
            if (matchValue[1].tag === 2) {
                if (matchValue[2].tag === 2) {
                    pattern_matching_result = 0;
                    contractAttributes = matchValue[2].fields[0];
                    feeTemplateNr = matchValue[0];
                    feeTemplates_1 = matchValue[1].fields[0];
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                const matchValue_1 = tryFind((ft_1) => (ft_1.FeeTemplateNr === parse(feeTemplateNr, 511, false, 32)), feeTemplates_1);
                if (matchValue_1 != null) {
                    return renderFeeTemplateModal(new FeeTemplateModalProps(props.GlobalDependencies, matchValue_1, () => {
                        editFeeTemplateModalState[1](void 0);
                    }, (ft_2) => {
                        let a_6, a_4, vm;
                        startImmediate((a_6 = ((a_4 = ((vm = ft_2, (feeTemplateSaveState[1](new SaveStatus(1)), singleton.Delay(() => singleton.Bind(saveFeeTemplate(props.GlobalDependencies.ClientNr, vm.FeeTemplateNr, toFeeTemplateDTO(vm)), (_arg_1) => {
                            const result_1 = _arg_1;
                            const arg_4 = (result_1.tag === 1) ? (new SaveStatus(3, result_1.fields[0])) : (new SaveStatus(2));
                            feeTemplateSaveState[1](arg_4);
                            return singleton.Return("Something other than unit needs to be returned here otherwise we cant Async.map this. This is a Fable issue not an F# issue.");
                        }))))), singleton.Delay(() => singleton.Bind(a_4, (_arg_8) => singleton.Return((editFeeTemplateModalState[1](void 0), "")))))), singleton.Delay(() => singleton.Bind(a_6, (_arg_10) => singleton.Return(loadFeeTemplates())))));
                    }, props.GlobalDependencies.ClientConfig.FeeConfig.UsesUnitPrice, contractAttributes));
                }
                else {
                    return error(toText(printf("Could not find FeeTemplate with id: %s"))(feeTemplateNr).split(""));
                }
            }
            case 1: {
                return react.createElement(react.Fragment, {});
            }
        }
    }, [[editFeeTemplateModalState[0], feeTemplatesState[0]]]);
    const createFeeTemplateModalHtml = react.useMemo(() => {
        const matchValue_2 = [createFeeTemplateModalIsOpenState[0], contractAttributesLoadState[0]];
        let pattern_matching_result_1;
        if (matchValue_2[0]) {
            if (matchValue_2[1].tag === 2) {
                pattern_matching_result_1 = 0;
            }
            else {
                pattern_matching_result_1 = 1;
            }
        }
        else {
            pattern_matching_result_1 = 1;
        }
        switch (pattern_matching_result_1) {
            case 0: {
                return renderFeeTemplateModal(new FeeTemplateModalProps(props.GlobalDependencies, void 0, () => {
                    createFeeTemplateModalIsOpenState[1](false);
                }, (ft_3) => {
                    let a_10, a_8;
                    startImmediate((a_10 = ((a_8 = ((feeTemplateSaveState[1](new SaveStatus(1)), singleton.Delay(() => singleton.Bind(createNewFeeTemplate(props.GlobalDependencies.ClientNr, toFeeTemplateDTO(ft_3)), (_arg_2) => {
                        const result_2 = _arg_2;
                        const arg_5 = (result_2.tag === 1) ? (new SaveStatus(3, result_2.fields[0])) : (new SaveStatus(2));
                        feeTemplateSaveState[1](arg_5);
                        return singleton.Return("Something other than unit needs to be returned here otherwise we cant Async.map this. This is a Fable issue not an F# issue.");
                    })))), singleton.Delay(() => singleton.Bind(a_8, (_arg_12) => singleton.Return((createFeeTemplateModalIsOpenState[1](false), "")))))), singleton.Delay(() => singleton.Bind(a_10, (_arg_14) => singleton.Return(loadFeeTemplates())))));
                }, props.GlobalDependencies.ClientConfig.FeeConfig.UsesUnitPrice, matchValue_2[1].fields[0]));
            }
            case 1: {
                return react.createElement(react.Fragment, {});
            }
        }
    }, [createFeeTemplateModalIsOpenState[0]]);
    let createButtonHtml;
    const children_2 = [main(new ButtonProps(getTranslation("ContractType.FeeTemplate.CreateFeeTemplate"), defaultProps.Content, (_arg_15) => {
        createFeeTemplateModalIsOpenState[1](true);
    }, defaultProps.Disabled, "fee-template-create-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))];
    createButtonHtml = react.createElement("div", {
        className: "fee-templates__create-button",
    }, ...children_2);
    let errorMessageHtml;
    const matchValue_3 = feeTemplateSaveState[0];
    errorMessageHtml = ((matchValue_3.tag === 3) ? error(matchValue_3.fields[0].split("")) : react.createElement(react.Fragment, {}));
    const matchValue_4 = feeTemplatesState[0];
    switch (matchValue_4.tag) {
        case 1: {
            return dotsLoading;
        }
        case 3: {
            return error(matchValue_4.fields[0].split(""));
        }
        case 2: {
            const activeFeeTemplates = filter((feeTemplate_1) => feeTemplate_1.Active, matchValue_4.fields[0]);
            const props_9 = [new HTMLAttr(65, stackClasses(ofArray(["fee-templates", "flex-column"])))];
            const children_8 = [(children_6 = [(arg_11 = getTranslation("ContractType.FeeTemplate.ContractTypeConnectedTemplates"), toText(printf("%s (%s)"))(arg_11)(props.ContractTypeCode))], react.createElement("h4", {}, ...children_6)), editFeeTemplateModalHtml, createFeeTemplateModalHtml, errorMessageHtml, createButtonHtml, renderFeeTemplateTable(new FeeTemplateTableProps((arg_15) => {
                editFeeTemplateModalState[1](arg_15);
            }, (feeTemplateNrStr) => {
                let a;
                startImmediate((a = deactivateFeeTemplate(props.GlobalDependencies.ClientNr, parse(feeTemplateNrStr, 511, false, 32)), singleton.Delay(() => singleton.Bind(a, (_arg_4) => singleton.Return(loadFeeTemplates())))));
            }, (feeTemplateNrStr_1) => {
                let a_2;
                startImmediate((a_2 = loadActivateFeeTemplate(props.GlobalDependencies.ClientNr, parse(feeTemplateNrStr_1, 511, false, 32)), singleton.Delay(() => singleton.Bind(a_2, (_arg_6) => singleton.Return(loadFeeTemplates())))));
            }, activeFeeTemplates))];
            return react.createElement("div", keyValueList(props_9, 1), ...children_8);
        }
        default: {
            return react.createElement(react.Fragment, {});
        }
    }
}, void 0, uncurry(2, void 0), void 0, "render", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\FeeTemplates\\ContractTypeFeeTemplates.fs", 197);

